import { z } from "zod";
import { EMAIL_ACTOR_TYPES, EMAIL_CATEGORIES, EMAIL_LOG_STATUSES } from "../queues.js";

/** Filtri della pagina "Log email" (Impostazioni) e di GET /api/email-log. */
export const emailLogQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(300).default(50),
  status: z.enum(EMAIL_LOG_STATUSES).optional(),
  category: z.enum(EMAIL_CATEGORIES).optional(),
  actorType: z.enum(EMAIL_ACTOR_TYPES).optional(),
  action: z.string().min(1).max(120).optional(),
  userId: z.string().uuid().optional(),
  /** Ricerca libera su destinatario e oggetto. */
  q: z.string().trim().min(1).max(200).optional(),
  from: z.string().datetime({ offset: true }).or(z.coerce.date()).optional(),
  to: z.string().datetime({ offset: true }).or(z.coerce.date()).optional(),
});
export type EmailLogQuery = z.infer<typeof emailLogQuerySchema>;
